module.exports = __webpack_public_path__ + "img/qr-btn-alpha.fbe2f362.png";